// import { BASE_URL } from "../constants/constants"
// base
// export const URL_BASE = "/"
// export const URL_BASE = BASE_URL ?? "/"
export const URL_BASE = "/"
// courseDetails
export const URL_COURSE_DETAILS = URL_BASE + "details/:id"
// login
export const URL_LOGIN = URL_BASE + "login"
export const URL_LOGIN_EMAIL = URL_LOGIN + "email/:email"
export const URL_LOGIN_PARAMS = URL_LOGIN + ":code?"
export const URL_LOGIN_COMPLETE_PASSWORDLESS = URL_LOGIN + "complete"
export const URL_LOGIN_COMPLETE_PASSWORDLESS_EMAIL = URL_LOGIN_COMPLETE_PASSWORDLESS + "email/:email"
export const URL_REGISTER = URL_BASE + "register"
// Aktivierungslink aus der Bestätigungs-Mail (sc-3358): Booker ohne eigenen Login
export const URL_ACTIVATE_ACCOUNT = URL_BASE + "activate-account/:token"
export const URL_REGISTER_SEPA_EDIT = URL_REGISTER + "sepa/edit"
export const URL_REGISTER_SEPA_EDIT_ID = URL_REGISTER + "sepa/edit/:id"
// export const URL_REGISTER_SEPA_CREATE = URL_REGISTER + "sepa/create"
// export const URL_REGISTER_SEPA_CREATE_BOOKERID = URL_REGISTER + "sepa/create/:bookerId"
// export const URL_REGISTER_SUCCESS = URL_REGISTER + "success"
export const URL_FORGOT_PASSWORD = URL_BASE + "forgotpassword"
export const URL_FORGOT_PASSWORD_SUCCESS = URL_FORGOT_PASSWORD + "success"
// account
export const URL_ACCOUNT = URL_BASE + "account"
export const URL_ACCOUNT_BOOKINGS = URL_ACCOUNT + "/bookings"
export const URL_ACCOUNT_BOOKING_DETAILS = URL_ACCOUNT_BOOKINGS + "/:bookingId"
export const URL_ACCOUNT_ATTENDEES = URL_ACCOUNT + "/attendees"
export const URL_ACCOUNT_PAYMENT = URL_ACCOUNT + "/payment"
export const URL_ACCOUNT_PROFILE = URL_ACCOUNT + "/profile"
// bookingFlow
export const URL_BOOKING = URL_BASE + "booking"
export const URL_BOOKING_STEPS = URL_BOOKING + "steps/:courseId"
export const URL_BOOKING_SUMMARY = URL_BOOKING + "summary/:courseId"
// results
export const URL_RESULTS = URL_BASE + "results/:resultType"
// agb
export const URL_AGB = URL_BASE + "agb"
// datenschutz
export const URL_DATENSCHUTZ = URL_BASE + "datenschutz"
// widerruf (öffentliche Widerruf-Seite, kein Auth-Guard)
export const URL_WIDERRUF = URL_BASE + "widerruf"
// Phase 9: Mollie Return-Page nach Hosted-Checkout-Redirect
export const URL_PAYMENT_RETURN = URL_BASE + "payment-return/:spId"
// Interessenten-Liste: öffentliche Details + login-pflichtige Anmeldung (ohne Zahlung)
export const URL_INTEREST_DETAILS = URL_BASE + "interest/:id"
export const URL_INTEREST_REGISTRATION = URL_INTEREST_DETAILS + "/register"
